export class InstallationService {
    /* @ngInject */
    constructor($http, egUrlService, $q, $log, $window) {
        this.$http = $http;
        this.egUrlService = egUrlService;
        this.$q = $q;
        this.$log = $log;
        this.$window = $window;
    }

    getInstallationUsers() {
        var url = this.egUrlService.url('/authentication/installationUsers');
        return this.$http.get(url)
            .then(response => { return response.data; })
            .catch(response => { return this._getAccountsError(response); });
    }

    _getAccountsError(response){
        this.$log.error('Failed to retrieve installations: ' + response.statusText);
        return this.$q.reject(response.data);
    }
}
